/* eslint react/no-array-index-key: 0 */
import { useMemo } from 'react';
import {
  PolylineF, OverlayView, OverlayViewF,
} from '@react-google-maps/api';
// import axios from 'axios';
import { useTheme } from 'styled-components';
import { ThemeType } from '../../../../theme/themeType';
import {
  OVERLAY_Z_IDX,
  getPosition,
  getEndPosition,
  getSmoothGooglePath,
  convertToGooglePath,
  getAngle,
} from '../helpers';
import VehicleSvg from '../VehicleMarker/driver-marker.svg';
import { Locations } from '../types';

function VehicleMarker({
  path, roadMatching, hasTripVehicleMarker,
}: {
  path: Locations;
  roadMatching: boolean;
  hasTripVehicleMarker?: boolean;
}): JSX.Element | null {
  const theme = useTheme() as ThemeType;
  const POLYLINE_COLOR = theme.colors.text;
  const startPosition = getPosition(path);
  const endPosition = getEndPosition(path);
  const smoothedPath = useMemo(
    () => (!roadMatching ? getSmoothGooglePath(path) : convertToGooglePath(path)),
    [path, roadMatching],
  );
  return (
    <>
      {hasTripVehicleMarker
        ? (
          <OverlayViewF
            position={startPosition}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            zIndex={OVERLAY_Z_IDX}
            getPixelPositionOffset={(width: number, height: number) => ({
              x: -(width / 2),
              y: -(height / 2),
            })}
          >
            <div style={{ transform: `rotate(${getAngle(path.slice(0, 2))}deg)` }}>
              <img src={VehicleSvg} alt="Custom Marker" width="30" height="30" />
            </div>
          </OverlayViewF>
        ) : (
          <OverlayViewF
            position={startPosition}
            mapPaneName={OverlayView.OVERLAY_LAYER}
            zIndex={OVERLAY_Z_IDX}
            getPixelPositionOffset={(width: number, height: number) => ({
              x: -(width / 2),
              y: -(height / 2),
            })}
          >
            <div style={{
              width: '12px',
              height: '12px',
              border: `2px solid ${theme.colors.text}`,
              borderRadius: '100px',
            }}
            />
          </OverlayViewF>
        )}
      <PolylineF
        path={smoothedPath}
        options={{
          strokeColor: POLYLINE_COLOR,
          strokeOpacity: 1,
          strokeWeight: 2,
        }}
      />
      <OverlayViewF
        position={endPosition}
        mapPaneName={OverlayView.OVERLAY_LAYER}
        zIndex={OVERLAY_Z_IDX}
        getPixelPositionOffset={(width: number, height: number) => ({
          x: -(width / 2),
          y: -(height / 2),
        })}
      >
        <div style={{
          width: '12px',
          height: '12px',
          background: theme.colors.main_cta,
          borderRadius: '100px',
        }}
        />
      </OverlayViewF>
    </>
  );
}

export default VehicleMarker;
